<template>
  <v-select
    @input="loadEvent"
    mandatory
    dense
    class="mt-5 ml-5"
    :value="$store.state.events.selected"
    :items="events"
    placeholder="Select an event"
    item-text="name"
    item-value="_id"
  >
    <template slot="selection" slot-scope="data">
      {{ data.item.name }} (Id:{{ data.item._id }})
    </template>
    <template slot="item" slot-scope="data">
      {{ data.item.name }} (Id:{{ data.item._id }})
    </template>
  </v-select>
</template>
<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      events: (state) => state.events.events,
      event: (state) => state.events.event
    })
  },
  async created() {
    if (this.$store.state.namespace) {
      const eventId = this.$store.state.namespace;
      await this.$store.dispatch('loadEvent', eventId);
    }
    await this.$store.dispatch('loadEvents');
  },
  methods: {
    async loadEvent(val) {
      this.$store.commit('SET_NAMESPACE', val);
      window.location.href = '/admin';
    }
  }
};
</script>
